import { CCReplaceReason } from 'components/features/creditCard/creditCardStore/types'
import { BaseFloatingPane } from 'interfaces/floatingPanes'

export const CREDIT_CARD_PANE = 'credit-card-management' as const

type CreditCardPaneBase<Payload> =
& BaseFloatingPane
& Payload
& {
  type: typeof CREDIT_CARD_PANE
}

/**========================================================================
 *                              LANDING PAGE
 *========================================================================**/

type SignupPane = CreditCardPaneBase<{
  mode: 'signup'
  email?: string
}>

type CardTermsPaneType = CreditCardPaneBase<{
  mode: 'terms'
}>

/**========================================================================
 *                              MANAGMENT
 *========================================================================**/

type CardMenuPaneType = CreditCardPaneBase<{
  mode: 'cardMenu'
}>

type SeeCardDetailsPaneType = CreditCardPaneBase<{
  mode: 'cardDetails'
}>

type ChangePinPaneType = CreditCardPaneBase<{
  mode: 'changePin'
}>

type StatementsPaneType = CreditCardPaneBase<{
  mode: 'statements'
}>

type WalletPaneType = CreditCardPaneBase<{
  mode: 'wallet'
}>

type BalancePaneType = CreditCardPaneBase<{
  mode: 'balance'
}>

type PaymentsPaneType = CreditCardPaneBase<{
  mode: 'payments'
}>

type ReplaceCardBase<Payload> = CreditCardPaneBase<{
  mode: 'replaceCard'
}> &
  Payload

export type ReplaceCardPaneStep = 'reason' | 'address' | 'result'

export type ReplaceCardPaneType = ReplaceCardBase<{
  step: ReplaceCardPaneStep
  reason?: CCReplaceReason
}>

type LockCardPaneType = CreditCardPaneBase<{
  mode: 'lockOrUnlock'
}>

/**========================================================================
 *                              PAYMENT METHODS
 *========================================================================**/

type PaymentMethodsPaneType = CreditCardPaneBase<{
  mode: 'paymentMethods'
}>

export type AddPaymentMethodPaneType = CreditCardPaneBase<{
  mode: 'addPaymentMethod'
}>

/**========================================================================
 *                              PAY CARD
 *========================================================================**/

export type SwipeablePayCardPaneStep =
  | 'amount'
  | 'paymentMethod'
  | 'date'
  | 'confirm'

export type PayCardPaneStep =
  | SwipeablePayCardPaneStep
  | 'success'

type PayCardBase<Payload> = CreditCardPaneBase<{
  mode: 'payCard'
  uid?: string
}> &
  Payload

type AutoPayCardBase<Payload> = CreditCardPaneBase<{
  mode: 'autoPay'
  uid?: string
}> &
  Payload

export type PayCardPaneType = PayCardBase<{
  step: PayCardPaneStep
}>

export type AutoPayCardPaneType = AutoPayCardBase<{
  step: PayCardPaneStep
}>

export type CreditCardFloatingPane =
  | SignupPane
  | CardTermsPaneType
  | CardMenuPaneType
  | SeeCardDetailsPaneType
  | PaymentMethodsPaneType
  | AddPaymentMethodPaneType
  | PayCardPaneType
  | AutoPayCardPaneType
  | ChangePinPaneType
  | ReplaceCardPaneType
  | LockCardPaneType
  | PaymentsPaneType
  | StatementsPaneType
  | BalancePaneType
  | WalletPaneType
